import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "brg-input-section" };
const _hoisted_2 = ["title", "data-cy"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Chip = _resolveComponent("Chip");
    const _component_v_list_item = _resolveComponent("v-list-item");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isHubSelectorExist)
            ? _withDirectives((_openBlock(), _createBlock(_component_v_autocomplete, {
                key: 0,
                "item-title": "text",
                "item-value": "value",
                modelValue: _ctx.selectedHubInfo,
                "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedHubInfo) = $event)),
                    _ctx.handleChangeSelectBox
                ],
                items: _ctx.options,
                class: "select-box",
                "hide-details": "auto",
                variant: "outlined",
                density: "compact",
                "bg-color": "white",
                "item-disabled": "disabled",
                "menu-props": { maxHeight: 500, maxWidth: 320 },
                disabled: _ctx.getterisHubSelectorDisabled,
                "data-cy": "hub-selector-autocomplete",
                eager: true,
                onKeyup: _cache[1] || (_cache[1] = ($event) => ($event.stopPropagation())),
                "onUpdate:focused": _ctx.handleBlurSelectBox
            }, {
                item: _withCtx(({ props, item }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: "",
                        disabled: item.raw.disabled,
                        class: "hub-selector-item"
                    }), {
                        default: _withCtx(() => [
                            (_ctx.isDistUser)
                                ? (_openBlock(), _createBlock(_component_Chip, {
                                    key: 0,
                                    class: "mr-3",
                                    "option-type": item.value.type,
                                    "option-id": item.value.id,
                                    "option-disabled": item.raw.disabled
                                }, null, 8 /* PROPS */, ["option-type", "option-id", "option-disabled"]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("span", {
                                title: `${item.value.id}`,
                                "data-cy": `hub-selector-autocomplete-item-${item.value.id}`
                            }, _toDisplayString(item.title), 9 /* TEXT, PROPS */, _hoisted_2)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["disabled"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "items", "disabled", "onUpdate:modelValue", "onUpdate:focused"])), [
                [_vShow, !_ctx.isHubSelectorHidden]
            ])
            : _createCommentVNode("v-if", true)
    ]));
}
